import type { NextPage } from 'next';

const Home: NextPage = () => {
  return <div>Home Page</div>;
};

export default Home;
